module.exports = __webpack_public_path__ + "img/tenir.907a6366.png";